















































import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import {
	mapActions,
	mapGetters,
	mapMutations,
	mapState,
} from 'vuex';
import DatesForm from '@/components/DatesForm.vue';
import ErrorList from '@/components/ErrorList.vue';
import ReservationSidebar from '@/components/ReservationSidebar.vue';
import ReservationSteps from '@/components/ReservationSteps.vue';
import TransitionExpand from '@/components/TransitionExpand.vue';
import ScreenLoader from '@/components/ui/ScreenLoader.vue';
import ReservationStepMixin from '@/mixins/reservationStepMixin';
import Customer from '@/models/Customer';
import Quote from '@/models/Quote';
import Reservation from '@/models/Reservation';
import ReservationStep from '@/types/reservationStep';

const Setup = Vue.extend({
	components: {
		ErrorList,
		DatesForm,
		ReservationSidebar,
		ReservationSteps,
		ScreenLoader,
		TransitionExpand,
	},
	computed: {
		...mapState(['isLoading']),
		...mapGetters(['customer']),
		...mapState('reservation', ['reservation']),
		...mapGetters('location', ['location']),
	},
	methods: {
		...mapMutations('reservation', ['clearQuote', 'reloadReservation', 'setOriginalReservation']),
		...mapActions('reservation', ['getQuotes']),
	},
});

@Component
export default class TheReservationEditPage extends mixins(Setup, ReservationStepMixin) {
	// State
	public isLoading!: boolean;
	public customer!: Customer;
	public reservation!: Reservation;

	// Getters
	public location!: Locations.Location;

	// Mutations
	public clearQuote!: () => void;
	public reloadReservation!: () => void;
	public setOriginalReservation!: () => void;

	// Actions
	public getQuotes!: (payload?: any) => Promise<Quote[]>;

	// Data
	public loadedReservation = false;

	public successMessage: string = '';

	public get shortcodeAttrs(): { [key: string]: string } {
		return this.$store.state.reservation.shortcodeAttrs;
	}

	public created() {
		// Make sure the reservation has been converted to a Reservation model.
		this.fetchData();
	}

	// Methods
	public async fetchData() {
		this.loadedReservation = false;
		this.reloadReservation();

		// Set the active location to the reservation's location
		const url = new URL(window.location.href);
		this.$store.dispatch('location/setLocationFromCode', `${url.searchParams.get('loc')}-${this.reservation.location}`);

		await this.getQuotes({ resRate: true });
		this.setOriginalReservation();
		this.loadedReservation = true;
		this.setStep(this.Step.Summary);
		this.$store.dispatch('reservation/getServices');
	}

	public async handleSubmittedDates() {
		this.clearQuote();
		try {
			const response = await this.getQuotes();
			this.setStep(ReservationStep.Quotes);
		} catch (error) {
			// Error getting quotes.
		}
	}

	public setSuccessMessage(message: string) {
		this.successMessage = message;
		window.scrollTo(0, 0);
	}
}
